var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "checkbox-inline"]
var hoisted5 = ["type", "checkbox"]
var hoisted6 = ["class", "checkbox-inline"]
var hoisted7 = ["type", "checkbox"]
var hoisted8 = ["class", "checkbox-inline"]
var hoisted9 = ["type", "checkbox"]
var __target

module.exports = function description (model) {
elementOpen("div", "9e01e3c2-a3c2-49c7-91bf-9fe37974285e", hoisted1)
  elementOpen("div")
    elementOpen("label", "b1d9caf9-f130-4185-a854-2b507c2aa132", hoisted2)
      elementOpen("input", "e9f9effb-c64b-426c-a190-76f9ce890ca3", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
    elementOpen("label", "d9c269cd-98b5-4f2e-8062-e04df805576c", hoisted4)
      elementOpen("input", "9a65b15e-040c-416b-9bda-a267d4d0c2a0", hoisted5, "checked", model.unique, "onchange", function ($event) {
        var $element = this;
      model.unique = this.checked})
      elementClose("input")
      text(" Unique \
          ")
    elementClose("label")
    elementOpen("label", "02008cdd-e350-41dd-bed2-785083ac8349", hoisted6)
      elementOpen("input", "3eed900f-63b1-41c1-a973-da6a2b17bbd2", hoisted7, "checked", model.auto, "onchange", function ($event) {
        var $element = this;
      model.auto = this.checked})
      elementClose("input")
      text(" Auto \
          ")
    elementClose("label")
    elementOpen("label", "dd3da29d-778d-4d47-a7a4-c1271e120a3b", hoisted8)
      elementOpen("input", "b5c065eb-7fd0-4f17-945b-daf629129cc8", hoisted9, "checked", model.index, "onchange", function ($event) {
        var $element = this;
      model.index = this.checked})
      elementClose("input")
      text(" Index \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
}
